var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRestaurantMidTier = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Restaurant-Menu--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Restaurant Menu Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 1.5A1.5 1.5 0 0 0 21.9 0H4.4a1.5 1.5 0 0 0 -1.5 1.5v0.75a0.5 0.5 0 0 0 0.5 0.5h0.95a0.75 0.75 0 0 1 0 1.5h-3a0.75 0.75 0 0 0 0 1.5h1a0.5 0.5 0 0 1 0.5 0.5v4a0.5 0.5 0 0 0 0.5 0.5h0.95a0.75 0.75 0 0 1 0 1.5h-3a0.75 0.75 0 1 0 0 1.5h1a0.5 0.5 0 0 1 0.5 0.5v4a0.5 0.5 0 0 0 0.5 0.5h0.95a0.75 0.75 0 1 1 0 1.5h-3a0.75 0.75 0 0 0 0 1.5h1a0.5 0.5 0 0 1 0.5 0.5v0.25A1.5 1.5 0 0 0 4.4 24h17.5a1.5 1.5 0 0 0 1.5 -1.5Zm-12 8.72a0.5 0.5 0 0 0 -0.28 0.45v6.83a0.75 0.75 0 0 1 -1.5 0v-6.83a0.49 0.49 0 0 0 -0.29 -0.45A2.44 2.44 0 0 1 7.9 8V6.7a2.45 2.45 0 0 1 4.9 0V8a2.45 2.45 0 0 1 -1.42 2.22Zm9.27 -2.47a3.49 3.49 0 0 1 -2.18 3.3 0.51 0.51 0 0 0 -0.32 0.47v6a0.75 0.75 0 0 1 -1.5 0v-6a0.51 0.51 0 0 0 -0.33 -0.47 3.49 3.49 0 0 1 -2.17 -3.3V5a0.75 0.75 0 1 1 1.5 0v2.75a2.12 2.12 0 0 0 0.57 1.47 0.23 0.23 0 0 0 0.27 0.06 0.24 0.24 0 0 0 0.16 -0.23V5a0.75 0.75 0 0 1 1.5 0v4.05a0.25 0.25 0 0 0 0.43 0.17 2.12 2.12 0 0 0 0.57 -1.47V5a0.75 0.75 0 0 1 1.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRestaurantMidTier);
export default ForwardRef;